import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/vibranium/vibranium/src/components/Layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "systems",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#systems",
        "aria-label": "systems permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Systems`}</h1>
    <p>{`A `}<inlineCode parentName="p">{`system`}</inlineCode>{` is a very loosely defined term in Vibranium. It can refer to different landscapes, applications, accounts, tenants etc.`}</p>
    <p>{`For example, If we have a dev landscape with three tenants, each having two users that are used for testing, then if we want to use them in Vibranium, it becomes six accounts, as follows:`}</p>
    <ol>
      <li parentName="ol"><strong parentName="li">{`dev_tenant1_user1`}</strong>{` : user1 credentials in dev tenant1 `}</li>
      <li parentName="ol"><strong parentName="li">{`dev_tenant1_user2`}</strong>{` : user2 credentials in dev tenant1 `}</li>
      <li parentName="ol"><strong parentName="li">{`dev_tenant2_user1`}</strong>{` : user1 credentials in dev tenant2 `}</li>
      <li parentName="ol"><strong parentName="li">{`dev_tenant2_user2`}</strong>{` : user2 credentials in dev tenant2 `}</li>
      <li parentName="ol"><strong parentName="li">{`dev_tenant3_user1`}</strong>{` : user1 credentials in dev tenant3 `}</li>
      <li parentName="ol"><strong parentName="li">{`dev_tenant3_user2`}</strong>{` : user2 credentials in dev tenant3 `}</li>
    </ol>
    <p>{`A better way to visualize this is using the JSON structure in `}<inlineCode parentName="p">{`config.json`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "dev_tenant1_read_access_user": {
        "url": "https://dev.tenant1.domain.com/ui",
        "api_url": "https://dev.tenant1.domain.com/api/v1",
        "method": "basic",
        "credentials": {
            "username": "readAccessUserName",
            "password": "readAccessUserPassword"
        }
    },
    "dev_tenant1_write_access_user": {
        "url": "https://dev.tenant1.domain.com/ui",
        "api_url": "https://dev.tenant1.domain.com/api/v1",
        "method": "basic",
        "credentials": {
            "username": "writeAccessUserName",
            "password": "writeAccessUserPassword"
        }
    },
    "dev_tenant1_read_access_user": {
        "url": "https://dev.tenant2.domain.com/ui",
        "api_url": "https://dev.tenant2.domain.com/api/v1",
        "method": "basic",
        "credentials": {
            "username": "readAccessUserName",
            "password": "readAccessUserPassword"
        }
    },
    "dev_tenant1_write_access_user": {
        "url": "https://dev.tenant2.domain.com/ui",
        "api_url": "https://dev.tenant2.domain.com/api/v1",
        "method": "basic",
        "credentials": {
            "username": "writeAccessUserName",
            "password": "writeAccessUserPassword"
        }
    },
    "dev_tenant1_read_access_user": {
        "url": "https://dev.tenant3.domain.com/ui",
        "api_url": "https://dev.tenant3.domain.com/api/v1",
        "method": "basic",
        "credentials": {
            "username": "readAccessUserName",
            "password": "readAccessUserPassword"
        }
    },
    "dev_tenant1_write_access_user": {
        "url": "https://dev.tenant3.domain.com/ui",
        "api_url": "https://dev.tenant3.domain.com/api/v1",
        "method": "basic",
        "credentials": {
            "username": "writeAccessUserName",
            "password": "writeAccessUserPassword"
        }
    }
}
`}</code></pre>
    <p>{`This configuration is maintained in the `}<a parentName="p" {...{
        "href": "../setup/1.5.config_json.md"
      }}>{`Config file`}</a>{`
To set one of these systems as the default, all you need to do is add the system name to the config json's `}<inlineCode parentName="p">{`default_account`}</inlineCode>{` key.`}</p>
    <h2 {...{
      "id": "usage",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#usage",
        "aria-label": "usage permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Usage`}</h2>
    <p>{`Once the systems are defined in the `}<inlineCode parentName="p">{`config.json`}</inlineCode>{`, to use the systems, you need to use the `}<inlineCode parentName="p">{`system`}</inlineCode>{` keyword (If you need to use any system other than the system marked as default).`}</p>
    <ul>
      <li parentName="ul">{`If the system is not specified anywhere in endpoint of in execution arguments, the default system is picked up.`}</li>
      <li parentName="ul">{`If the system is specified in the execution level, using `}<inlineCode parentName="li">{`--system`}</inlineCode>{` option [`}<a parentName="li" {...{
          "href": "../cli/2.4.vc_r.md"
        }}>{`Refer here`}</a>{`], then that system is picked up. You can override the default system to say `}<inlineCode parentName="li">{`dev_tenant1_write_access_user`}</inlineCode>{` by specifying `}<inlineCode parentName="li">{`--system default=dev_tenant1_write_access_user`}</inlineCode></li>
      <li parentName="ul">{`If the system is specified at the endpoint level, using the `}<inlineCode parentName="li">{`system`}</inlineCode>{` key [`}<a parentName="li" {...{
          "href": "3.2.endpoint_object.md"
        }}>{`Refer here`}</a>{`], then this takes priority and this system is picked up for execution.`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`If in any case the system specified is not found in the config.json, then the default system specified in the config.json is automatically picked up.`}</p>
    </blockquote>
    <h2 {...{
      "id": "examples",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#examples",
        "aria-label": "examples permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "some_system_with_no_auth": {
        "url": "https://reqres.in/",
        "api_url": "https://reqres.in",
        "method": "none"
    },
    "some_random_name_for_my_system_with_basic_auth": {
        "url": "SYSTEM_UI_URL",
        "api_url": "API_ENDPOINT",
        "method": "basic",
        "credentials": {
            "username": "MY_SUPER_SECRET_USERNAME",
            "password": "MY_SUPER_SECRET_PASSWORD"
        }
    },
    "another_system_that_uses_jwt_token_based_auth": {
        "url": "SYSTEM_UI_URL",
        "api_url": "API_ENDPOINT",
        "method": "oauth2",
        "oauth_url": "OAUTH_TOKEN_URL_FOR_THE_SYSTEM",
        "credentials": {
            "clientid": "MY_SUPER_SECRET_CLIENT_ID",
            "secret": "MY_SUPER_SECRET_CLIENT_SECRET"
        }
    },
    "github_api_v3_basic_auth": {
        "url": "",
        "api_url": "https://api.github.com/v3",
        "method": "basic",
        "credentials": {
            "username": "MY_SUPER_SECRET_USERNAME",
            "password": "MY_SUPER_SECRET_PASSWORD",
        }
    }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      